import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const CropZoneBlockId = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      id="cropZonePermitId"
      name="cropZonePermitId"
      placeholder="Enter crop zone block ID"
      label="Crop Zone Block ID"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default CropZoneBlockId;
